interface Props {
  percentage: number;
}

const CustomProgressBar: React.FC<Props> = ({ percentage }) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

  return (
    <div className="relative w-full">
      <div className="w-full h-1 bg-gray-300 rounded-full overflow-hidden">
        <div
          className="h-full bg-yellow-400"
          style={{ width: `${clampedPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default CustomProgressBar;
